module.exports = __webpack_public_path__ + "static/media/linkedin.524c0070.svg";